const state = {
	data: {
		can_install: false
	}
}

const getters = {
	CAN_INSTALL : state => {
		return state.data.can_install
	}
}

const mutations = {
	SET_CAN_INSTALL : (state, payload) => {
		state.data.can_install = payload
	}
}

const actions = {
	SET_CAN_INSTALL : async (context, canInstall) => {
		context.commit('SET_CAN_INSTALL', canInstall)
	}
}

export default {
	state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/modules/installApp.js